import React from 'react';

type LoadingSpinnerSize = 'md' | 'sm' | 'xs';

interface LoadingSpinnerComponentProps {
    size?: LoadingSpinnerSize;
}

function LoadingSpinnerComponent(props: LoadingSpinnerComponentProps): JSX.Element {
    const {size = 'md'} = props;

    function getSpinnerSize(): string {
        if (size) return `c-loader--${size}`;

        return '';
    }

    return (
        <div className={`c-loader ${getSpinnerSize()}`} data-cy="loader_component">
            <div className="c-loader__loader" />
        </div>
    );
}

export default LoadingSpinnerComponent;
